import React from "react";
import { Platform } from "react-native";

export interface OverlayProps {
  isVisible?: boolean;
}

export const Overlay = ({
  isVisible = true,
}: OverlayProps): React.ReactElement | null => {
  if (Platform.OS !== "web" || !isVisible) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
      }}
    />
  );
};
